/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class  AuthenticationServices {


    getLocale(){
        return (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
    };

    authenticate(username , password){
        return ApplicationServices.call(Constants.AUTHENTICATE , 
            {method:'website' , username:username , pass:password, adminLogin:true}).then(function(response){
            Action.update(Constants.ON_AUTHENTICATE , response.newToken);
            return response.newToken;
        });
    };

    isAuthenticated(){
        Action.update(Constants.ON_AUTHENTICATE , String(sessionStorage.getItem('USER_TOKEN')).length > 20);
    }
}

export default new AuthenticationServices();